import * as React from 'react';

/* tslint:disable:max-line-length */

interface IProps {
  type: string;
}

const plane = (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 16V14L13.5789 9V3.5C13.5789 2.67 12.8737 2 12 2C11.1263 2 10.4211 2.67 10.4211 3.5V9L2 14V16L10.4211 13.5V19L8.31579 20.5V22L12 21L15.6842 22V20.5L13.5789 19V13.5L22 16Z" fill="#41A5F5"/>
  </svg>
);

const planeAnnual = (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 14.9219L7.54545 15.6506V17.1852L5.90909 18.3511V19.517L8.77273 18.7398L10 18.3511V14.9219Z" fill="#41A5F5"/>
    <path d="M10 8.84375V4.16591C10 3.52077 9.45182 3 8.77273 3C8.09364 3 7.54545 3.52077 7.54545 4.16591V7.46932L1 11.3557V12.9102L5.3024 11.633L10 8.84375Z" fill="#41A5F5"/>
    <path d="M23 16V14L14.5789 9V3.5C14.5789 2.67 13.8737 2 13 2C12.1263 2 11.4211 2.67 11.4211 3.5V9L3 14V16L11.4211 13.5V19L9.31579 20.5V22L13 21L16.6842 22V20.5L14.5789 19V13.5L23 16Z" fill="#41A5F5"/>
  </svg>

)

export default ({type}: IProps) => {
  switch (type) {
    case 'single':
      return plane;
    case 'annual':
      return planeAnnual;
    default:
      console.error('No type provided');
  }
};
